import axios from "axios";
const api = process.env.REACT_APP_API_URL;

export const fetchAllSiteManagementService = async (
  pageNumber,
  pageSize,
  access_token,
  userId,
  debouncedSearch = "",
) => {
  try {
    return axios.get(
      `${api}/Site/GetSiteGridData?userId=${userId}&pageNumber=${
        debouncedSearch !== "" ? 1 : pageNumber
      }&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getOnLoadSiteDataService = async (
  access_token,
  userId,
  id = null,
) => {
  try {
    const url =
      id !== null
        ? `${api}/Site/AddEditSiteOnload?tabPage=1&UserId=${userId}&id=${id}`
        : `${api}/Site/AddEditSiteOnload?tabPage=1&UserId=${userId}`;
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`,
      },
    });
  } catch (err) {
    return err;
  }
};

export const addUpdateSiteService = async (access_token, data, userId) => {
  try {
    return axios.post(`${api}/Site/AddEdit?UserId=${userId}`, data, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const updateSiteService = async (access_token, data, id, userId) => {
  try {
    return axios.post(
      `${api}/Site/UpdateSite?Id=${id}&userId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchSiteDetailsById = async (access_token, id) => {
  try {
    return axios.get(`${api}/Site/GetSiteById?Id=${id}`, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const fetchAllBulkSiteDataService = async (
  pageNumber,
  pageSize,
  access_token,
  userId,
  debouncedSearch = "",
) => {
  try {
    return axios.get(
      `${api}/Site/SiteBulkUpdateOnload?userId=${userId}&pageNumber=${pageNumber}&pageSize=${pageSize}&filter=${debouncedSearch}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const saveBulkEditSiteService = async (
  access_token,
  data,
  userId,
  enrollmentAlias,
) => {
  try {
    return axios.post(
      `${api}/Site/SiteBulkUpdate?UserId=${userId}&EnrollmentAlias=${enrollmentAlias}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getStudySiteCapDataService = async (
  access_token,
  id,
  capLevelTypeId = null,
) => {
  try {
    const url =
      id !== null
        ? `${api}/Study/CapsIndex?SiteId=${id}&CapLevelTypeId=${capLevelTypeId !== null ? capLevelTypeId : "09F7B307-B506-491C-BB6B-78D973CEFFD3"}`
        : `${api}/Study/CapsIndex?CapLevelTypeId=${capLevelTypeId !== null ? capLevelTypeId : "09F7B307-B506-491C-BB6B-78D973CEFFD3"}`;
    return axios.get(url, {
      headers: {
        Authorization: `Bearer ${access_token}`, // Attach access token
        "Content-Type": "application/json", // Optional, depends on API requirements
      },
    });
  } catch (err) {
    return err;
  }
};

export const addStudyCapsService = async (
  access_token,
  userId,
  globalDateFormat,
  data,
) => {
  try {
    return axios.post(
      `${api}/Study/AddCap?UserId=${userId}&GlobalDateFormat=${globalDateFormat}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const updateStudyDetailsService = async (
  access_token,
  userId,
  globalDateFormat,
  siteId,
  data,
) => {
  try {
    return axios.post(
      `${api}/Study/UpdateCaps?UserId=${userId}&siteId=${siteId}&globalDateFormat=${globalDateFormat}&capLevelTypeId=09F7B307-B506-491C-BB6B-78D973CEFFD3`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const deleteSiteCap = async (
  access_token,
  userId,
  deleteId,
  siteId,
  globalDateFormat,
) => {
  try {
    return axios.get(
      `${api}/Study/DeleteCap?UserId=${userId}&capId=${deleteId}&capLevelTypeId=09F7B307-B506-491C-BB6B-78D973CEFFD3&siteId=${siteId}&GlobalDateFormat=${globalDateFormat}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchDataForIndividualDrugStatus = async (
  id,
  pageNumber,
  pageSize,
  studyId,
  userId,
  access_token,
  debouncedSearch = "",
) => {
  try {
    return axios.post(
      `${api}/SiteDrugStatus/GetDrugStatusGridData?pageNumber=${pageNumber}&pageSize=${pageSize}&id=${id}&locationTypeId=${0}&StudyId=${studyId}&UserId=${userId}&filter=${debouncedSearch}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchStatusLoadDataService = async (access_token, id, userId) => {
  try {
    return axios.get(
      `${api}/SiteDrugStatus/IndexOnload?id=${id}&UserId=${userId}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getOnLoadDataForSiteLanguagesService = async (
  access_token,
  siteId,
) => {
  try {
    return axios.get(`${api}/Site/SiteLanguagesOnload?SiteId=${siteId}`, {
      headers: {
        Authorization: `Bearer ${access_token}`,
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    return err;
  }
};

export const submitSiteLanguagesDataService = async (
  access_token,
  siteId,
  siteNumber,
  userId,
  data,
) => {
  try {
    return axios.post(
      `${api}/Site/SiteLanguagesPost?siteId=${siteId}&SiteNumber=${siteNumber}&UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const submitIndividualStatusDataService = async (
  access_token,
  userId,
  data,
) => {
  try {
    return axios.post(
      `${api}/SiteDrugStatus/PostDrugStatus?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchBulkKitStatusOnLoadService = async (
  access_token,
  siteId,
  userId,
) => {
  try {
    return axios.post(
      `${api}/SiteDrugStatus/BulkIndexOnload?id=${siteId}&locationTypeId=0&UserId=${userId}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getBulkKitStatusDrugNumberService = async (
  access_token,
  studyId,
  userId,
  data,
) => {
  try {
    return axios.post(
      `${api}/SiteDrugStatus/GetCountOfDrug?StudyId=${studyId}&UserId=${userId}&locationTypeId=0`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const saveBulkDataForKtStatusService = async (
  access_token,
  data,
  siteId,
  studyId,
  userId,
  updateDrugStatusId,
) => {
  try {
    return axios.post(
      `${api}/SiteDrugStatus/PostBulkDrugStatus?siteId=${siteId}&StudyId=${studyId}&userId=${userId}&locationTypeId=${0}&DrugStatusIdToUpdate=${updateDrugStatusId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const fetchOnLoadReconcilliationSiteDataService = async (
  access_token,
  siteId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/SiteReconciliation/IndexOnload?siteId=${siteId}&patientId=${""}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const submitReconcilliationDatService = async (
  access_token,
  data,
  userId,
) => {
  try {
    return axios.post(
      `${api}/SiteReconciliation/PostSiteReconciliation?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const getSiteReturnDataService = async (
  access_token,
  siteId,
  cultureCode,
) => {
  try {
    return axios.get(
      `${api}/SiteReconciliation/IndexOnload?siteId=${siteId}&CurrentSiteUserCultureCode=${cultureCode}`,
      {
        headers: {
          Authorization: `Bearer ${access_token}`,
          "Content-Type": "application/json",
        },
      },
    );
  } catch (err) {
    return err;
  }
};

export const submitReturnDataService = async (access_token, data, userId) => {
  try {
    return axios.post(
      `${api}/SiteReturnToDepot/PostSiteReturn?UserId=${userId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${access_token}`, // Attach access token
          "Content-Type": "application/json", // Optional, depends on API requirements
        },
      },
    );
  } catch (err) {
    return err;
  }
};
